import { useIoContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
export function useIsNativeAppleSignIn() {
    const { native } = useIoContext();
    return native.platform === 'ios';
}
export function useIsAppleSignInVisible() {
    const { native } = useIoContext();
    const { APPLE_WEB_LOGIN } = useFeatureFlags();
    return native.platform === 'ios' || native.platform === 'web' && APPLE_WEB_LOGIN === true;
}
